import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ion-padding" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, " This FI was generated for this parent places: ", -1)
const _hoisted_3 = { key: 1 }

import { TPlace } from '@/const/types/place';
import { BasicModal } from '@components/basic';
import BasicEntryModalContent from '@/components/basic/BasicEntryModalContent.vue';
import ArticlePlaceCardBase from '@/components/article/ArticlePlaceCardBase.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FIDocumentPlacesModal',
  props: {
    places: null,
    isOpen: { type: Boolean },
    isAllWarehouse: { type: Boolean },
    isMoreItemsToload: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    places: TPlace[];
    isOpen: boolean;
    isAllWarehouse: boolean;
    isMoreItemsToload: boolean;
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BasicModal), {
    modelValue: props.isOpen,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((props.isOpen) = $event))
  }, {
    title: _withCtx(() => [
      _createTextVNode(" FI for places ")
    ]),
    default: _withCtx(() => [
      _createVNode(BasicEntryModalContent, {
        "can-load-more": props.isMoreItemsToLoad,
        "is-loading": props.isLoading
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!props.isAllWarehouse)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_2,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.places, (place) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: place.id
                    }, [
                      _createVNode(ArticlePlaceCardBase, { place: place }, null, 8, ["place"])
                    ]))
                  }), 128))
                ], 64))
              : (_openBlock(), _createElementBlock("h4", _hoisted_3, " This FI was generated for all warehouse. "))
          ])
        ]),
        _: 1
      }, 8, ["can-load-more", "is-loading"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})